import { useSelector } from 'react-redux';
import { UserProfileDetailsSelector, UserProfileHasARoleSelector } from '@store/selectors/UserProfileSelector';
import { HospitalRoles, OfficeRoles } from '@interfaces/UserProfile/UserRoleEnum';

export const useIsChatEnabled = () => {
	const hasHospitalRole = useSelector(UserProfileHasARoleSelector(HospitalRoles));
	const hasOfficeRole = useSelector(UserProfileHasARoleSelector(OfficeRoles));
	const { chatEnabled } = useSelector(UserProfileDetailsSelector);
	const isChatEnabled = hasHospitalRole ? chatEnabled : hasOfficeRole;

	return { isChatEnabled };
};
